import type { FormattedScoring } from '@/helpers/scoring-helper';

import { MonetizationType, ObjectType } from '@/@types/graphql-types';
import { SCORINGS, ScoringProvider } from '@/helpers/scoring-helper';

import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export type ScoringProviderType = ScoringProvider.IMDB | ScoringProvider.ROTTEN_TOMATOES;

interface PlotRecommenderFilters {
	packages: string[];
	objectTypes: ObjectType[];
	price: {
		min: number | null;
		max: number | null;
	};
	scorings: Record<ScoringProviderType, { min: number; max?: number }>;
	monetizationTypes: MonetizationType[];
}

export const providerScoring = Object.fromEntries(SCORINGS.map(s => [s.provider, s])) as Record<
	ScoringProviderType,
	FormattedScoring
>;

function getInitialFilters(): PlotRecommenderFilters {
	return {
		packages: [],
		objectTypes: [],
		price: {
			min: null,
			max: null,
		},
		scorings: {
			[ScoringProvider.IMDB]: { min: providerScoring.imdb.min },
			[ScoringProvider.ROTTEN_TOMATOES]: { min: providerScoring.rottentomatoes.min },
		},
		monetizationTypes: [],
	};
}

export const usePlotRecommenderStore = defineStore('lpPlotRecommender', () => {
	const filters = ref(getInitialFilters());

	const isAnyFilterActive = computed(
		() =>
			filters.value.price.min != null ||
			filters.value.price.max != null ||
			Object.values(filters.value.scorings).some(s => s.min !== 0) ||
			filters.value.monetizationTypes.length > 0
	);

	function resetFilters() {
		filters.value = getInitialFilters();
	}

	return {
		filters,
		isAnyFilterActive,

		resetFilters,
	};
});
